import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

import { DateService } from '../../services/date.service';
import { DateNavigationState, navigateDatesByOneDay } from '../../utils/date-range.utils';

interface DateSelectionState {
  selectedDates: Date[];
  startDatePicker: Date | null;
  endDatePicker: Date | null;
}

const initialState: DateSelectionState = {
  selectedDates: [],
  startDatePicker: null,
  endDatePicker: null,
};

export const DateSelectorStore = signalStore(
  withState(initialState),

  withMethods((store) => {
    const dateService = inject(DateService);

    return {
      initializeDates(startDate: Date, endDate: Date): void {
        const datesRange = dateService.generateDaysBetweenDates(startDate, endDate);
        const startDatePicker = datesRange[0] || null;
        const endDatePicker = datesRange.length > 1 ? datesRange[datesRange.length - 1] : null;
        patchState(store, {
          selectedDates: datesRange,
          startDatePicker: startDatePicker,
          endDatePicker: endDatePicker,
        });
      },

      moveDatesByOneDay(direction: -1 | 1): void {
        const currentState: DateNavigationState = {
          selectedDates: store.selectedDates(),
          startDatePicker: store.startDatePicker(),
          endDatePicker: store.endDatePicker(),
        };
        const newState = navigateDatesByOneDay(currentState, direction, dateService);
        patchState(store, newState);
      },

      updateStartDate(date: Date | null): void {
        patchState(store, { startDatePicker: date });

        if (!date || !store.endDatePicker()) return;

        const datesRange = dateService.generateDaysBetweenDates(date, store.endDatePicker());
        patchState(store, { selectedDates: datesRange });
      },

      updateEndDate(date: Date | null): void {
        patchState(store, { endDatePicker: date });

        if (!date || !store.startDatePicker()) return;

        const datesRange = dateService.generateDaysBetweenDates(store.startDatePicker(), date);
        patchState(store, { selectedDates: datesRange });
      },
    };
  }),
);
